/**
 * The chat's actions (Call from Telnyx, SMS Patient, Call Patient, Transfer
 * Chat, End Chat) belong in ChatBuilder's top bar, but their state lives in
 * ChatPanelHeader. The top bar renders an empty slot with this id and
 * ChatPanelHeader portals the actions into it, so they sit in the top bar's
 * flex row instead of being pinned with position: fixed at hard-coded right
 * offsets, which put them on top of the bar's own notices.
 */
export const TOP_BAR_ACTIONS_ID = 'chat-top-bar-actions'
